module.exports = __webpack_public_path__ + "img/q7-opt-a.863d52a8.png";